import { Button, Form, Row, Col, Card } from 'react-bootstrap';
import LoginBackgroundURL from '../../assets/img/bg-login.jpeg';
import { DOMAIN_NAME } from '../../config/default.js';
import { 
    DOMAIN_NAME as DOMAIN_FIDUCIAL,
    PORTAL_URL as FIDUCIAL_PORTAL_URL,
    APP_EXPLORE_ICON_URL as FIDUCIAL_LOGO,
    APP_EXPLORE_ICON_CONF as FIDUCIAL_LOGO_CONF,
    BRAND_NAME as FIDUCIAL_BRAND
} from '../../config/fiducial.js';
import {
    DOMAIN_NAME as DOMAIN_FEDERATED,
    PORTAL_URL as FEDERATED_PORTAL_URL,
    APP_EXPLORE_ICON_URL as FEDERATED_LOGO,
    APP_EXPLORE_ICON_CONF as FEDERATED_LOGO_CONF,
    BRAND_NAME as FEDERATED_BRAND 
} from '../../config/federated.js';
import { 
    DOMAIN_NAME as DOMAIN_JADE,
    PORTAL_URL as JADE_PORTAL_URL,
    APP_EXPLORE_ICON_URL as JADE_LOGO,
    APP_EXPLORE_ICON_CONF as JADE_LOGO_CONF,
    BRAND_NAME as JADE_BRAND
} from '../../config/jade.js';
import './Explore.scss';
import { connect } from 'react-redux';

const PortalCard = ({logo, logoConf, portalUrl, brand}) => {
    return (
        <Col lg={4} className="auth-box shadow m-2 p-4 pb-5 pt-5 mb-5rounded bg-blur-effect rounded">
            <a href={portalUrl} rel="noopener noreferrer" target="_blank">
                <Row className="flex-column" style={{height:"280px"}}>
                    <Col className="align-self-center flex-grow-1" style={{...logoConf}} />
                    <Col className="text-center align-self-center flex-grow-0">
                        <Button className="text-decoration-none" variant="link">Access {brand} Portal</Button>
                    </Col>
                </Row>
            </a>
        </Col>
    );
}

const Explore = ({userProfile}) => {
    return (
        <Row className="explore d-flex justify-content-center" style={{backgroundImage: `url(${LoginBackgroundURL})`}}>
            <Col className="d-flex flex-column justify-content-center align-items-center">
                <Row>
                    <div className="display-6 mb-4">Access different contracts on</div>
                </Row>
                <Row>
                    {DOMAIN_NAME !== DOMAIN_FIDUCIAL && userProfile._othersVAccounts[DOMAIN_FIDUCIAL]?.length > 0 ? (
                        <PortalCard 
                            logo={FIDUCIAL_LOGO}
                            logoConf={FIDUCIAL_LOGO_CONF}
                            portalUrl={FIDUCIAL_PORTAL_URL}
                            brand={FIDUCIAL_BRAND}
                        />
                    ) : null}
                    {DOMAIN_NAME !== DOMAIN_FEDERATED && userProfile._othersVAccounts[DOMAIN_FEDERATED]?.length > 0 ? (
                        <PortalCard 
                            logo={FEDERATED_LOGO}
                            logoConf={FEDERATED_LOGO_CONF}
                            portalUrl={FEDERATED_PORTAL_URL}
                            brand={FEDERATED_BRAND}
                        />
                    ) : null}
                    {DOMAIN_NAME !== DOMAIN_JADE && userProfile._othersVAccounts[DOMAIN_JADE]?.length > 0 ? (
                        <PortalCard 
                            logo={JADE_LOGO}
                            logoConf={JADE_LOGO_CONF}
                            portalUrl={JADE_PORTAL_URL}
                            brand={JADE_BRAND}
                        />
                    ) : null}
                </Row>
            </Col>
        </Row>
    );
}

const mapStateToProps = (appState) => ({
    userProfile: appState.userProfile
});

export default connect(mapStateToProps)(Explore);
